import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_INCIDENT_DATA_SUCCESS,
  INCIDENT_DETAILS_SET_CONTENT_LINK_SELLER,
} from '../../../../actions/actionTypes';

const defaultState = null;

const contentLinkSeller = (state = defaultState, action) => {
  switch (action.type) {
    case INCIDENT_DETAILS_FETCH_INCIDENT_DATA_SUCCESS: {
      const seller = action.payload.response.data.contentLink?.seller ?? null;
      return seller;
    }

    case INCIDENT_DETAILS_SET_CONTENT_LINK_SELLER:
      return action.payload.seller;

    case INCIDENT_DETAILS_CLEAR:
      return defaultState;

    default:
      return state;
  }
};

export default contentLinkSeller;
